import React, { useEffect } from 'react';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllApplications } from './library/libraryActions';

export default function SiteMap() {
  const dispatch = useDispatch();
  const { applications } = useSelector((state) => state.library);

  useEffect(() => {
    dispatch(fetchAllApplications());
  }, [dispatch]);

  return (
    <Fragment>
      <div class='pageBody' style={{ marginTop: 100 }}>
        <xml version='1.0' encoding='UTF-8' />
        <urlset xmlns='http://www.sitemaps.org/schemas/sitemap/0.9'>
          {applications &&
            applications.map((application) => {
              return (
                <url>
                  <loc>
                    {'https://languagelearninglibrary.com/view/' +
                      application.slug}
                  </loc>
                  <lastmod>
                    {application &&
                      application.created_date &&
                      application.created_date.replace(' ', 'T') + '+01:00'}
                  </lastmod>
                </url>
              );
            })}
        </urlset>
      </div>
    </Fragment>
  );
}
